export const overHalfOfTotalCommandsDownloaded = (
  downloadedCommands: boolean[],
  totalCommands: number
): boolean => {
  const numberOfDownloadedCommands = downloadedCommands.filter(
    (c: boolean) => c
  ).length;
  return numberOfDownloadedCommands >= Math.ceil(totalCommands / 2);
};

export const getLogRangeHeader = (range?: {
  rangeStart?: number;
  rangeEnd?: number;
}) => {
  if (!range?.rangeEnd) return {};

  return {
    Range: `bytes=${range?.rangeStart ?? 0}-${range?.rangeEnd ?? ''}`,
  };
};
